/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import Shell from '../../common/components/Shell/Shell';
import { Grid } from '@mui/material';
import EmpDirectoryPresenter from './EmpDirectoryPresenter';
import DTOEmpDirectory from './DTOEmpDirectory';
import { useAppSelector } from '../../infra/hooks';
import { useTranslation } from 'react-i18next';
import _ from "lodash";

function EmpDirectoryController() {
  const { t, i18n } = useTranslation();

  const [empDirectory, setempDirectory] = useState([]);
  const [allDepartment, setallDepartment] = useState([]);
  const [pageNumber, setPageNumber] = useState<any>(0);
  const [totalEmpDirectory, setTotalEmpDirectory] = useState<any>(0);
  const [page, setPage] = useState(0);
  const [rowPerPage, setRowsPerPage] = useState(10)
  const [count, setCount] = useState(100)
  const [textFilterSearch, setTextFilterSearch] = useState();
  const [search, setSearchTerm] = useState(textFilterSearch);
  const [isDept, setIsDept] = useState<any>();

  const isLoading = useAppSelector((state) => state.LoaderSlice.Loading);
  function callBackFunc(data: any) {
    setempDirectory(data);
  }
  async function callBackDepartments(data: []) {
    setallDepartment(data);
  }

  function getPageNumber(data: any) {
    setPageNumber(data);
  }

  async function getTotalEmpDirectory(total: any) {
    setTotalEmpDirectory(total);
  }

  async function getPageValue(page:any) {
    setPage(page)
  }

  async function getRowPerPageValue(row:any) {
    setRowsPerPage(row)
  }

  async function getPageDetails(data:any){
    setCount(data?.total)
  }

  const handlegetEmpdocDept = (dept: any) => {
    setIsDept(dept);
  };

  const setSearch = (search:any) =>{
    setTextFilterSearch(search)
  }
  useEffect(()=>{
    const timer = setTimeout(()=>setSearchTerm(textFilterSearch),1000)
    return () => clearTimeout(timer)
  },[textFilterSearch])
  return (
    <>
      <Shell>
        <Grid
          container
          style={{
            maxWidth: 'auto',
            marginLeft: i18n.language == 'en' ? '7.25em' : '',
          }}
        >
          <EmpDirectoryPresenter
            EmpDirectory={empDirectory}
            allDepartment={allDepartment}
            isLoading={isLoading}
            setPageChange={getPageNumber}
            totalEmpDirectory={totalEmpDirectory}
            trans={t}
            i18n={i18n}
            getPageValue={getPageValue}
            getRowPerPageValue={getRowPerPageValue}
            page={page}
            rowPerPage={rowPerPage}
            count={count}
            handlegetEmpdocDept={handlegetEmpdocDept}
            setSearch={setSearch}
          />
        </Grid>
      </Shell>
      <DTOEmpDirectory
        setEmpDirectory={callBackFunc}
        pageNumber={pageNumber}
        setAllDepartments={callBackDepartments}
        setTotalEmpDirectory={getTotalEmpDirectory}
        page={page}
        rowPerPage={rowPerPage}
        setPageDetails={getPageDetails}
        filterDept={isDept}
        search={search}
      />
    </>
  );
}
export default EmpDirectoryController;
